import { Badge as BadgeBase } from 'antd';
import { BadgeProps } from 'antd/lib/badge';
import React from 'react';

export interface IBadgeProps extends BadgeProps {}

const Badge: React.FC<IBadgeProps> = ({ ...props }) => {
  return <BadgeBase {...props} />;
};

export default Badge;
